function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.117647%,94.117647%,94.117647%)",
      fillOpacity: 1
    },
    d: "M 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 C 0 5.371094 5.371094 0 12 0 C 18.628906 0 24 5.371094 24 12 Z M 24 12 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,32.156863%,70.588235%)",
      fillOpacity: 1
    },
    d: "M 2.480469 4.695312 C 1.539062 5.921875 0.828125 7.335938 0.414062 8.871094 L 6.65625 8.871094 Z M 2.480469 4.695312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,32.156863%,70.588235%)",
      fillOpacity: 1
    },
    d: "M 23.585938 8.871094 C 23.171875 7.335938 22.460938 5.921875 21.519531 4.695312 L 17.34375 8.871094 Z M 23.585938 8.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,32.156863%,70.588235%)",
      fillOpacity: 1
    },
    d: "M 0.414062 15.128906 C 0.828125 16.667969 1.539062 18.078125 2.480469 19.304688 L 6.65625 15.128906 Z M 0.414062 15.128906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,32.156863%,70.588235%)",
      fillOpacity: 1
    },
    d: "M 19.304688 2.480469 C 18.078125 1.539062 16.664062 0.828125 15.128906 0.414062 L 15.128906 6.65625 Z M 19.304688 2.480469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,32.156863%,70.588235%)",
      fillOpacity: 1
    },
    d: "M 4.695312 21.519531 C 5.921875 22.460938 7.335938 23.171875 8.871094 23.585938 L 8.871094 17.34375 Z M 4.695312 21.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,32.156863%,70.588235%)",
      fillOpacity: 1
    },
    d: "M 8.871094 0.414062 C 7.335938 0.828125 5.921875 1.539062 4.695312 2.480469 L 8.871094 6.65625 Z M 8.871094 0.414062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,32.156863%,70.588235%)",
      fillOpacity: 1
    },
    d: "M 15.128906 23.585938 C 16.664062 23.171875 18.078125 22.460938 19.304688 21.519531 L 15.128906 17.34375 Z M 15.128906 23.585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,32.156863%,70.588235%)",
      fillOpacity: 1
    },
    d: "M 17.34375 15.128906 L 21.519531 19.304688 C 22.460938 18.078125 23.171875 16.667969 23.585938 15.128906 Z M 17.34375 15.128906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,0%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 23.898438 10.433594 L 13.566406 10.433594 L 13.566406 0.101562 C 13.054688 0.0351562 12.53125 0 12 0 C 11.46875 0 10.945312 0.0351562 10.433594 0.101562 L 10.433594 10.433594 L 0.101562 10.433594 C 0.0351562 10.945312 0 11.46875 0 12 C 0 12.53125 0.0351562 13.054688 0.101562 13.566406 L 10.433594 13.566406 L 10.433594 23.898438 C 10.945312 23.964844 11.46875 24 12 24 C 12.53125 24 13.054688 23.964844 13.566406 23.898438 L 13.566406 13.566406 L 23.898438 13.566406 C 23.964844 13.054688 24 12.53125 24 12 C 24 11.46875 23.964844 10.945312 23.898438 10.433594 Z M 23.898438 10.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,0%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 15.128906 15.128906 L 20.484375 20.484375 C 20.730469 20.238281 20.964844 19.980469 21.191406 19.714844 L 16.605469 15.128906 Z M 15.128906 15.128906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,0%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 8.871094 15.128906 L 3.515625 20.484375 C 3.761719 20.730469 4.019531 20.964844 4.285156 21.191406 L 8.871094 16.605469 Z M 8.871094 15.128906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,0%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 8.871094 8.871094 L 3.515625 3.515625 C 3.269531 3.761719 3.035156 4.019531 2.808594 4.285156 L 7.394531 8.871094 Z M 8.871094 8.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,0%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 15.128906 8.871094 L 20.484375 3.515625 C 20.238281 3.269531 19.980469 3.035156 19.714844 2.808594 L 15.128906 7.394531 Z M 15.128906 8.871094 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbp);
export default __webpack_public_path__ + "static/media/GBP.fe4888f753b0a63268970254c3098c37.svg";
export { ForwardRef as ReactComponent };